<template>
	<div class="page">
		<top-header></top-header>
		<b-container fluid >
		<b-row class="mb-3">
			<top-nevleft></top-nevleft>
			
		 <b-col >
			
		<b-container fluid class="p-0 mt-2">
			
				<b-row class="m-0">
					<b-col class="col-md-12 col-sm-12 col-xs-12">
						<div class="container-box">
							<b-row class="mt-4 px-3">
								<b-col lg="6" class="text-left">
									<span class="mr-2">Show</span>
									<b-form-select v-model="perPage" id="perPageSelect" :options="pageOptions" size="sm" class="w-25">
									</b-form-select>
									
								</b-col>
								<b-col lg="4" offset-md="2">
									<b-form-group label="Filter" label-cols-sm="3" label-align-sm="right" label-size="sm" label-for="filterInput" class="mb-0">
										<b-input-group size="sm">
											<b-form-input v-model="filter" type="search" id="filterInput" placeholder="Type to Search">
											</b-form-input>
											<b-input-group-append>
												<b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
											</b-input-group-append>
										</b-input-group>
									</b-form-group>
								</b-col>
							</b-row>
							<b-row class="px-3 pt-3">
								<b-col lg="12">
									<b-table show-empty sticky-header small striped outlined id="my-table" stacked="md" :items="records" :fields="fields" :current-page="currentPage" :per-page="perPage" :filter="filter" :filterIncludedFields="filterOn" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :sort-direction="sortDirection" @filtered="onFiltered">
										
										<template v-slot:cell(created_at)="row">
											{{$moment(row.value).format('DD-MM-YYYY')}}										
										</template>
										
										<template v-slot:cell(status)="row">
											<b-link @click="replayEmail(row.item)" v-if="row.value == 0"><b-badge pill variant="warning">Reply</b-badge></b-link>
											<b-badge pill variant="success" v-else>Replyed</b-badge>										
										</template>
										
										<template v-slot:cell(actions)="row">
											<b-button pill variant="outline-primary" class="mr-1 icon-btn" @click="showUpdateModal(row.item, row.index, $event.target)"><b-icon icon="pencil" font-scale="1.6" ></b-icon></b-button>
											<b-button pill variant="outline-danger" class="mr-1 icon-btn" @click="showDeleteModal(row.item)"><b-icon icon="trash" font-scale="1.6" ></b-icon></b-button>
											
										</template>
									</b-table>
								</b-col>
							</b-row>
							<b-row class="px-3">
								<b-col lg="6" class="text-left">
									<span class="mr-2">Showing {{currentPage}} to {{(perPage>records.length)?records.length:perPage}} of {{records.length}} entries</span>
								</b-col>
								<b-col lg="3" offset-md="3">
									<b-pagination v-model="currentPage" pills :total-rows="totalRows" :per-page="perPage" align="right" size="sm" prev-text="Prev" next-text="Next" first-number last-number></b-pagination>
								</b-col>
							</b-row>
						</div>
					</b-col>
				</b-row>
				
				
						<b-modal id="my-model" :title="(selectedItem.id > 0)?'Edit Brand':'Add Brand'" size="lg" ok-only @hidden="resetSelectedItem" @ok="modalSubmit">
							<form ref="form" @submit.stop.prevent="handleSubmit">
								<b-container fluid>
									<b-tabs content-class="mt-3" small>
										<b-tab title="Brand" href="#product">
											<b-row class="mb-1">
												<b-col cols="12">
													<b-row class="mb-3">
														<b-col cols="3" class="text-right"><label class="font-sm">Brand Name</label></b-col>
														<b-col><b-form-input v-model="selectedItem.brand_name" size="sm" :maxlength="100" required></b-form-input></b-col>
													</b-row>
													<b-row class="mb-3">
														<b-col cols="3" class="text-right"><label class="font-sm">About Brand</label></b-col>
														<b-col>
															<b-form-textarea v-model="selectedItem.about_brand" size="sm" rows="3" :maxlength="250" required></b-form-textarea>
															<small class="float-right">{{250-selectedItem.about_brand.length}}/250 Character Remaining</small>	
														</b-col>
														
													</b-row>
													<b-row class="mb-3">
														<b-col cols="3" class="text-right"><label class="font-sm">Brand Logo</label></b-col>
														<b-col>
															<b-form-file type="file" v-model="product_inf.product_image_1" accept=".jpeg,.jpg,.png" size="sm" placeholder="Choose a Image"></b-form-file>
															<b-form-text id="password-help-block">{{selectedItem.brand_logo}}</b-form-text>
														</b-col>
													</b-row>
													
													<!--<b-row class="mb-3">
														<b-col cols="3" class="text-right"><label class="font-sm">Status</label></b-col>
														<b-col cols="4">
															<b-form-select v-model="selectedItem.status" size="sm" required>
																<b-form-select-option value="1">Active</b-form-select-option>
																<b-form-select-option value="2">In Active</b-form-select-option>
															</b-form-select>
														</b-col>
													</b-row> -->
													
													
												</b-col>
											</b-row>
										</b-tab>
									</b-tabs>
									
								</b-container>
							</form>
							<template v-slot:modal-footer="{ ok, close }">
								<b-button size="sm" variant="danger" @click="close()">Cancel</b-button>
								<b-button size="sm" variant="success" @click="ok()">{{(selectedItem.id > 0)?'Update':'Submit'}}</b-button>
							</template>
						</b-modal>			
				

				
			
		</b-container>
		<transition name="fade">
			<b-row v-if="loading" class="loading" style="position: absolute; top:0px; left:0px; right:0px; bottom:0px; z-index: 1000; background-color: rgba(0,0,0,0.4);" align-v="center" align-h="center">
				<b-spinner label="Busy" variant="light"></b-spinner>
			</b-row>
		</transition>
			<top-footer></top-footer>
		</b-col>
		</b-row>
		</b-container>
		<replayemail-popup :userData="selected" :subjectT="subjectT" fromEmail="contactus"></replayemail-popup>
	</div>
	
</template>
<script>
import '@/assets/profileuser.scss';
//import Header from "@/components/seller/Header.vue";
import Header from "@/components/header.vue";
import TreeviewPage from "@/components/admin/nevleft.vue";
import Footer from "@/components/footer-admin.vue";
import ReplayemailPopup from "@/components/admin/replayemail-popup.vue";

export default {
	name: 'Devices',
	components: {
		"top-header": Header,
		"top-footer": Footer,
		"top-nevleft": TreeviewPage,
		"replayemail-popup": ReplayemailPopup,
		
	},
	mounted(){
		//var self = this;
		//Object.assign(self.selectedItem, self.emptyItem);
		this.initload();
	},
	data() {
		return{
            loading: true, 
            thumbnailProps: { blank: false, width: 60, height: 60, class: 'm1' },
            product_inf: {},
		
			/*product_glb: '',*/
			model_maps: {},
			recordUrl: this.$root.WEBAPI+'secureapi/getContactus',
			selected:{},
			subjectT:'',
			//insertUrl: this.$root.WEBAPI+'sellerapi/brand-insert',
			//insertUrl: this.$root.NEWAPIURL+'sellerapi/getContactus',
			
			filteredCategory: [],
			category: [],
			records: [],
			categoryOptions: [],
			breadcrumb: [
				{
					text: 'Home',
					href: '/'
				},
				{
					text: 'Brands',
					active: true
				}
			],
			fields: [
				{ key: 'id', label: 'ID'},
				{ key: 'fullname', label: 'Name'},				
				{ key: 'email', label: 'Email'},
				{ key: 'mobile', label: 'Phone' },
				{ key: 'area_Of_interest', label: 'Area Of Interest'},
				{ key: 'assist', label: 'Assist' },
				//{ key: 'heard_about', label:'How did you hear about us' },
				{ key: 'subject', label:'Subject'},
				{ key: 'message', label:'Message'},
				//{ key: 'ipaddress', label:'IP'},
				{ key: 'created_at', label:'Post Date'},
				{ key: 'status', label:'Actions'},
				//{ key: 'actions', label: 'Actions', 'extra': 1, class: 'text-right' }
			],
			totalRows: 1,
			currentPage: 1,
			pageOptions: [10, 20, 50, 100],
			perPage: 10,
			sortBy: '',
			sortDesc: false,
			sortDirection: 'asc',
			filter: null,
			filterOn: [],
			selectedItem: {
				about_brand: '',
				short_description: '',
				product_data:{}, 
				tier_price:[], 
				gallery_images:["","","",""]
			},
			emptyItem: {
				id: 0,
				brand_name: '',
				about_brand: '',
				brand_logo: '',
				gallery_images:[""],
                status: 0
			},
			counterindex:1
		};
	},
	methods: {		
		showAddModal(){
			this.selectedItem = Object.assign({}, this.emptyItem);
			this.$root.$emit('bv::show::modal', 'my-model');
		},
		showUpdateModal(item, index, button) {
			this.selectedItem = Object.assign({}, item);
			if(item.product_data){
				this.selectedItem.product_data = JSON.parse(item.product_data);
			}
			if(item.tier_price){
				this.selectedItem.tier_price = JSON.parse(item.tier_price);
			}
			if(item.gallery_images){
				this.selectedItem.gallery_images = JSON.parse(item.gallery_images);
			}
			if(item.variation_attributes){
				this.selectedItem.variation_attributes = item.variation_attributes.split('|');
			}
			if(item.variations){
				this.selectedItem.variations = JSON.parse(item.variations);
			}
			this.$root.$emit('bv::show::modal', 'my-model', button)
		},
		showCsvModal(item){
			var self = this;
			this.$bvModal.msgBoxConfirm('Please confirm that you want to generate product csv!.', {
				title: 'Please Confirm',
				size: 'sm',
				buttonSize: 'sm',
				okVariant: 'success',
				okTitle: 'YES',
				cancelTitle: 'NO',
				footerClass: 'p-2',
				hideHeaderClose: false,
				centered: true
			})
			.then(value => {
				if(value == true){
					self.axios.post(self.csvgenUrl, {
						accesskey: self.$session.get('access_key'),
						product_id: item.id
					})
					.then(function (response) {
						if(response.data.error == 0 || response.data.error == '0'){

							self.$bvToast.toast(response.data.message, {
								title: 'Delete',
								toaster: 'b-toaster-bottom-right',
								autoHideDelay: 5000,
								variant: 'warning',
								solid: true,
								appendToast: true
							});
							
							
						}
						
					})
					.catch(function (error) {
						alert(error);
					});
				}else{
					//alert('no '+item.id);
				}
			})
			.catch(err => {
				// An error occurred
				console.log(err);
			})
		},
		showDeleteModal(item){
			var self = this;
			this.$bvModal.msgBoxConfirm('Please confirm that you want to delete Brand!.', {
				title: 'Please Confirm',
				size: 'sm',
				buttonSize: 'sm',
				okVariant: 'danger',
				okTitle: 'YES',
				cancelTitle: 'NO',
				footerClass: 'p-2',
				hideHeaderClose: false,
				centered: true
			})
			.then(value => {
				if(value == true){
					self.axios.post(self.deleteUrl, {
						accesskey: self.$session.get('access_key'),
						delete_id: item.id
					})
					.then(function (response) {
						if(response.data.error == 0 || response.data.error == '0'){
							self.$bvToast.toast(response.data.message, {
								title: 'Delete',
								toaster: 'b-toaster-bottom-right',
								autoHideDelay: 5000,
								variant: 'warning',
								solid: true,
								appendToast: true
							});
							self.initload();
						}
						
					})
					.catch(function (error) {
						alert(error);
					});
				}else{
					//alert('no '+item.id);
				}
			})
			.catch(err => {
				// An error occurred
				console.log(err);
			})
		},
		modalSubmit(bvModalEvt){
			var self = this;
			self.loading = true;
			bvModalEvt.preventDefault();
			var submitUrl = "";
			if(self.selectedItem.id == 0){
				submitUrl = self.insertUrl;
			}else{
				submitUrl = self.updateUrl;
            }

            let formData = new FormData();
			formData.append('imagefile1', this.product_inf.product_image_1);
			/*formData.append('imagefile2', this.product_inf.product_image_2);
			formData.append('imagefile3', this.product_inf.product_image_3);
			formData.append('imagefile4', this.product_inf.product_image_4);*/
			formData.append('data', JSON.stringify(this.selectedItem));
            formData.append('accesskey', this.$session.get('access_key'));

            self.axios.post(submitUrl, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            })
			.then(function (response) {
				if(response.data.error == 0 || response.data.error == '0'){
					self.$bvModal.hide('my-model');
					self.$bvToast.toast(response.data.message, {
						title: 'Status',
						toaster: 'b-toaster-bottom-right',
						autoHideDelay: 5000,
						variant: 'warning',
						solid: true,
						appendToast: true
					});
					self.product_inf.product_image_1 = '';
					self.product_inf.product_image_2 = '';
					self.product_inf.product_image_3 = '';
					self.product_inf.product_image_4 = '';
					self.initload();
				}
				
			})
			.catch(function (error) {
				alert(error);
			});
		},
		
		

		resetSelectedItem(){
			var self = this;
			self.selectedItem = Object.assign({}, self.emptyItem);
		},
		initload(){
			var self = this;
			
			self.axios.post(self.recordUrl, {
				accesskey: self.$session.get('access_key')
			})
			.then(function (response) {
				if(response.data.error == 0 || response.data.error == '0'){
					self.records = response.data.result.contactList;
					console.log(self.records);
					//self.category = response.data.result.category; 
					self.loading = false;
					self.totalRows = self.records.length;

					self.filteredCategory = [];
					//self.filterChildCategory(0, 0, 0);
				}else if(response.data.error == 9){
					self.$root.forceLogout(response.data.message);
				}
				//setTimeout(self.initload, 1000*30);
			})
			.catch(function (error) {
				alert(error);
			});
			//alert('login '+self.email+" "+self.password);
		},
		/*filtercategory(records){
			var filterarr = new Array();
			records.forEach(function(row){
				var dataarr = new Array();
				self.fields.forEach(function(field){
					if(field.key != 'extra'){
						dataarr.push(row[field.key]);
					}
				});
				finalarr.push(dataarr);
			});
		},*/
		onFiltered(filteredItems) {
			this.totalRows = filteredItems.length
			this.currentPage = 1
		},
		replayEmail(item){
			var self = this;
			self.selected=item;
			self.subjectT=item.subject;
			self.$root.$emit('bv::show::modal', 'showShareEmailModal');
			
		}
	}
}
</script>
<style>
</style>